import { get } from 'lodash-es';

export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    target: {
      type: Object,
      required: true,
    },
    classes: {
      type: [Array, String],
      default: () => [],
    },
    iconBidirectional: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    link() {
      if (this.target.type === 'phone') {
        return `tel:${this.localizedPhoneNumber}`;
      }

      if (['page', 'external'].includes(this.target.type)) {
        return this.target.link;
      }

      return '#';
    },

    localizedPhoneNumber() {
      const currentCountry = window.Phoenix && window.Phoenix.currentCountry;
      if (currentCountry) {
        return get(this.target, ['numbers', currentCountry, 'phoneNumber'], '');
      }
      return '';
    },

    localizedPhoneNumberLabel() {
      const currentCountry = window.Phoenix && window.Phoenix.currentCountry;
      if (currentCountry) {
        return get(this.target, ['numbers', currentCountry, 'phoneLabel'], '');
      }
      return '';
    },

    getText() {
      if (this.target.type === 'phone') {
        return `<span dir="ltr">${this.text.replace('{number}', this.localizedPhoneNumberLabel)}</span>`;
      }
      return this.text;
    },

    attributes() {
      const attributes = {};
      if (this.target.type === 'page' && this.target.openInNewWindow) {
        attributes.target = '_blank';
      }
      return attributes;
    },

    baseClasses() {
      return [];
    },

    getClasses() {
      const classes = typeof this.classes === 'string' ? this.classes.split() : this.classes;
      return this.baseClasses.concat(classes);
    },
  },
};
